/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ entity: NonNullable<unknown> }} General_Assigned_ItemsInputs */

const en_general_assigned_items = /** @type {(inputs: General_Assigned_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assigned ${i?.entity}`)
};

const de_general_assigned_items = /** @type {(inputs: General_Assigned_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zugewiesene ${i?.entity}`)
};

/**
* | output |
* | --- |
* | "Assigned {entity}" |
*
* @param {General_Assigned_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_assigned_items = /** @type {((inputs: General_Assigned_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Assigned_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_assigned_items(inputs)
	return de_general_assigned_items(inputs)
});